import React from 'react';
import { LanguageProvider } from './i18n.js';
import { Slider } from './slider.js';
import { SubscriptionStatusBanner } from './subscriptionStatus.js';
import { SubscriptionsManager } from './subscriptions.js';
import { ThemeToggle } from './theme.js';
import { LanguageSelector } from './i18n.js';
import { Edito } from './edito.js';
import { SectionNav } from './sectionNav.js';
import { History } from './history.js';
import { DistributorsCard } from './distributors.js';
import { Oma } from './oma.js';
import { ThoughtCard } from './thought.js';
import { CollectionCard } from './collection.js';
import { ScrollToTop } from './scrollToTop.js';
import { Footer } from './footer.js';
import { CookieConsentManager } from './cookieConsentUI.js';
import { PasswordGate, isSiteUnlocked } from './passwordGate.js';

export function App({ lang, initialData = {} }) {
  return (
    <LanguageProvider initialLang={lang}>
      <Slider initialData={initialData.slider} />
      <SubscriptionStatusBanner />
      <SubscriptionsManager />
      <div className="top-controls">
        <ThemeToggle />
        <LanguageSelector />
      </div>
      <SectionNav />
      <Edito initialData={initialData.edito} />
      <History initialData={initialData.history} />
      <DistributorsCard initialData={initialData.distributors} />
      <Oma initialData={initialData.oma} />
      <CollectionCard initialData={initialData.collection} />
      <ThoughtCard initialData={initialData.thought} />
      <ScrollToTop />
      <Footer />
      <CookieConsentManager />
    </LanguageProvider>
  );
}

export function Root({ lang, initialData }) {
  // Le rendu serveur affiche toujours PasswordGate (pas de sessionStorage côté Node) : l'état
  // initial côté client doit être identique (`false`) pour que l'hydratation réconcilie le même
  // arbre. Le vrai statut (déjà déverrouillé dans une session précédente) n'est vérifié qu'après
  // coup, dans un effet — sinon React plante en tentant de réconcilier <PasswordGate> (serveur)
  // avec <App> (client), voir erreurs d'hydratation #418/#423.
  const [unlocked, setUnlocked] = React.useState(false);

  React.useEffect(() => {
    if (isSiteUnlocked()) {
      setUnlocked(true);
    }
  }, []);

  if (!unlocked) {
    return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  }

  return <App lang={lang} initialData={initialData} />;
}
